import { render, staticRenderFns } from "./byTagSalesRepartition.vue?vue&type=template&id=6a507a61&scoped=true"
import script from "./byTagSalesRepartition.vue?vue&type=script&lang=js"
export * from "./byTagSalesRepartition.vue?vue&type=script&lang=js"
import style0 from "./byTagSalesRepartition.vue?vue&type=style&index=0&id=6a507a61&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a507a61",
  null
  
)

export default component.exports